<template>
  <div class="widget-temps-access">
    <div class="card">
        <div class="card-header"><h5>Ara mateix {{ data.datatempsacces }}</h5>
           </div>
        <div>
            <span class="badge border-radius-0 subtitol" >Temps accés a {{ data.terminal }}</span>
        </div>

        <div class="card-body" style="text-align:center">
          <AccesTimeIcon />
        </div>


        <div class="card-body" style="text-align:center">
          <div class="temps-acces-time">
          Temps Accés
           <h1 style="display: inline-block;">
              {{ data.tempsacces }} m.
            </h1>

          </div>
           
           
        </div>

      <div class="card-body">  

       <img class="card-img-top" :src="data.urlcam">

      </div>
             
    </div>
  </div>
</template>
<script>
import AccesTimeIcon from './Icons/AccesTimeIcon.vue';
export default {
  name: 'Tempsacces',
  components: { AccesTimeIcon },
  props: {
    data: Object
  },
}
</script>